import { render } from "./AlertsInfo.vue?vue&type=template&id=11918188"
import script from "./AlertsInfo.vue?vue&type=script&lang=js"
export * from "./AlertsInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__